
import "./ShimmerLoading.css";

const ShimmerLoading = () => {
  return (
    <div className="shimmer-container">
      {/* Avatar */}
      <div className="shimmer-avatar"></div>

      {/* Title + subtitle */}
      <div className="shimmer-title"></div>
      <div className="shimmer-subtitle"></div>

      {/* Button */}
      <div className="shimmer-button"></div>

      {/* Tabs */}
      <div className="shimmer-tabs">
        <div></div>
        <div></div>
      </div>

      {/* Card blocks */}
      <div className="shimmer-card"></div>
      <div className="shimmer-card"></div>
    </div>
  );
};

export default ShimmerLoading;
